"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canEnableSessionTracking = void 0;
var _init = require("../../common/config/init");
var _runtime = require("../../common/constants/runtime");
/**
 * Checks if session can be tracked, affects session entity and dependent features
 * @param {string} agentId
 * @returns {boolean}
 */
const canEnableSessionTracking = agentId => {
  return _runtime.isBrowserScope && (0, _init.getConfigurationValue)(agentId, 'privacy.cookies_enabled') === true;
};
exports.canEnableSessionTracking = canEnableSessionTracking;